export default __webpack_public_path__ + "images/0x135f9b3d5dec9d73c042cf380adfff95f4fe9e35.png";